import { render } from "./ProblemsTable.vue?vue&type=template&id=39a39ca0&ts=true"
import script from "./ProblemsTable.ts?vue&type=script&lang=ts&external"
export * from "./ProblemsTable.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__